export default "__VITE_ASSET__CUTO1t$4__"